// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3-7Cd","content":"LoadingAlert_content__T-tfS"};